export enum AddressValidationResultType {
  NotFound = 'NotFound',
  FoundWithChanges = 'FoundWithChanges',
  FoundWithFullCompliance = 'FoundWithFullCompliance',
}
